import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import moment from 'moment';
import topTitle from '@/components/title.vue';
import { recursionCopy } from '@/views/customer/roleManage/utils';
import { planArea } from '@/views/insurance/insuranceManage/request';
import { areaData } from '@/utils/city';
import { balckListResource } from '@/views/groupOrderManage/batchInsurance/request';
import { isPhone, checkEmail, isCardNo } from '@/utils/validate';
export default {
  components: {
    topTitle
  },
  props: ['isAdd', 'templateData', 'formResult', 'checkFieldData'],
  data() {
    return {
      showdata: [],
      data: [],
      areaList: areaData,
      isPass: false,
      companyBlackList: [],
      personBlackList: []
    };
  },
  computed: {
    rules() {
      let obj = {};
      this.showdata.map((item, index) => {
        item.map((item1, index1) => {
          item1.item.map((item2, index2) => {
            // if (!item2.isOptional) {
            obj[item2.code + index] = [{
              required: !item2.isOptional ? true : false,
              validator: (rule, value, callback) => {
                if (this.showdata[index][index1].item[index2].checkResult) {
                  return callback(new Error(this.$t(this.showdata[index][index1].item[index2].checkResult.replace('保险生效时间同为', this.$t('保险生效时间同为')).replace('重复', this.$t('重复')))));
                }
                if (!this.showdata[index][index1].item[index2].inputKey && !this.showdata[index][index1].item[index2].isOptional) {
                  return callback(new Error(this.$t(item2.display == 'text' ? '请输入' : '请选择') + this.$t(this.showdata[index][index1].item[index2].name)));
                } else {
                  if (this.showdata[index][index1].item[index2].display == 'text' && this.showdata[index][index1].item[index2].inputKey.length > 100) {
                    return callback(new Error(this.$t('最多输入100字符')));
                  } else if (this.showdata[index][index1].item[index2].name.includes('手机号')) {
                    if (this.showdata[index][index1].item[index2].inputKey && !isPhone(this.showdata[index][index1].item[index2].inputKey)) {
                      return callback(new Error(this.$t('请填写正确的') + this.$t(this.showdata[index][index1].item[index2].name)));
                    }
                  } else if (this.showdata[index][index1].item[index2].name.includes('邮箱')) {
                    if (this.showdata[index][index1].item[index2].inputKey && !checkEmail(this.showdata[index][index1].item[index2].inputKey)) {
                      return callback(new Error(this.$t('请填写正确的') + this.$t(this.showdata[index][index1].item[index2].name)));
                    }
                  } else if (this.showdata[index][index1].item[index2].name.includes('证件号')) {
                    let findIndex = this.showdata[index][index1].item.findIndex(i => i.name.includes('证件类型') && i.inputKey == 'IDCARD' && i.inputValue === '身份证');
                    if (this.showdata[index][index1].item[index2].inputKey && !isCardNo(this.showdata[index][index1].item[index2].inputKey) && findIndex > -1) {
                      return callback(new Error(this.$t('请填写正确的') + this.$t(this.showdata[index][index1].item[index2].name)));
                    }
                  } else if (this.showdata[index][index1].item[index2].code == 'appliIdNo' && isCardNo(this.showdata[index][index1].item[index2].inputKey)) {
                    let has = this.showdata[index][index1].item.findIndex(c => c.code == 'appliBirthday');
                    if (has > -1 && this.showdata[index][index1].item[has].inputKey) {
                      let birth = this.showdata[index][index1].item[index2].inputKey.substr(6, 4) + '-' + this.showdata[index][index1].item[index2].inputKey.substr(10, 2) + '-' + this.showdata[index][index1].item[index2].inputKey.substr(12, 2);
                      if (moment(this.showdata[index][index].item[has].inputKey).format('YYYY-MM-DD') != birth) {
                        return callback(new Error(this.$t('投保人生日与证件号不符')));
                      }
                    }
                  } else if (this.showdata[index][index1].item[index2].code == 'appliBirthday' && this.showdata[index][index1].item[index2].inputKey) {
                    let has = this.showdata[index][index1].item.findIndex(c => c.code == 'appliIdNo');
                    if (has > -1 && isCardNo(this.showdata[index][index1].item[has].inputKey)) {
                      let birth = this.showdata[index][index1].item[has].inputKey.substr(6, 4) + '-' + this.showdata[index][index1].item[has].inputKey.substr(10, 2) + '-' + this.showdata[index][index1].item[has].inputKey.substr(12, 2);
                      if (moment(this.showdata[index][index1].item[index2].inputKey).format('YYYY-MM-DD') != birth) {
                        return callback(new Error(this.$t('投保人生日与证件号不符')));
                      }
                    }
                  } else if (this.showdata[index][index1].item[index2].code == 'insuredIdNo' && isCardNo(this.showdata[index][index1].item[index2].inputKey)) {
                    let has = this.showdata[index][index1].item.findIndex(c => c.code == 'insuredBirthday');
                    if (has > -1 && this.showdata[index][index1].item[has].inputKey) {
                      let birth = this.showdata[index][index1].item[index2].inputKey.substr(6, 4) + '-' + this.showdata[index][index1].item[index2].inputKey.substr(10, 2) + '-' + this.showdata[index][index1].item[index2].inputKey.substr(12, 2);
                      if (moment(this.showdata[index][index].item[has].inputKey).format('YYYY-MM-DD') != birth) {
                        // this.showdata[index][index1].item[has].inputKey = '';
                        return callback(new Error(this.$t('被保人生日与证件号不符')));
                      }
                    }
                  } else if (this.showdata[index][index1].item[index2].code == 'insuredBirthday' && this.showdata[index][index1].item[index2].inputKey) {
                    let has = this.showdata[index][index1].item.findIndex(c => c.code == 'insuredIdNo');
                    if (has > -1 && isCardNo(this.showdata[index][index1].item[has].inputKey)) {
                      let birth = this.showdata[index][index1].item[has].inputKey.substr(6, 4) + '-' + this.showdata[index][index1].item[has].inputKey.substr(10, 2) + '-' + this.showdata[index][index1].item[has].inputKey.substr(12, 2);
                      if (moment(this.showdata[index][index1].item[index2].inputKey).format('YYYY-MM-DD') != birth) {
                        // this.showdata[index][index1].item[i4].inputKey = '';
                        return callback(new Error(this.$t('被保人生日与证件号不符')));
                      }
                    }
                  } else if (this.showdata[index][index1].item[index2].code == 'startDate' && this.showdata[index][index1].item[index2].inputKey) {
                    let end = this.showdata[index][index1].item.findIndex(c => c.code == 'endDate');
                    if (end > -1 && this.showdata[index][index1].item[end].inputKey) {
                      if (moment(this.showdata[index][index1].item[end].inputKey).isBefore(this.showdata[index][index1].item[index2].inputKey)) {
                        // this.showdata[index][index1].item[index2].inputKey = '';
                        return callback(new Error(this.$t('开始时间不得超过结束时间')));
                        // return this.$message.warn(this.$t('开始时间不得超过结束时间'));
                      }
                    }
                  } else if (this.showdata[index][index1].item[index2].code == 'endDate' && this.showdata[index][index1].item[index2].inputKey) {
                    let start = this.showdata[index][index1].item.findIndex(c => c.code == 'startDate');
                    if (start > -1 && this.showdata[index][index1].item[start].inputKey) {
                      if (moment(this.showdata[index][index1].item[index2].inputKey).isBefore(this.showdata[index][index1].item[start].inputKey)) {
                        return callback(new Error(this.$t('开始时间不得超过结束时间')));
                      }
                    }
                  } else if (this.showdata[index][index1].item[index2].name == '与投保人关系' && this.showdata[index][index1].item[index2].inputKey == '01') {
                    var _applicantInfo$item;
                    let res = true;
                    let applicantInfo = this.showdata[index].find(i => i.code == 'applicant');
                    if (applicantInfo && (_applicantInfo$item = applicantInfo.item) !== null && _applicantInfo$item !== void 0 && _applicantInfo$item.length) {
                      applicantInfo.item.forEach((app, appIndex) => {
                        let name = '';
                        if (app.name.indexOf('姓名') > -1) {
                          name = '姓名';
                        } else if (app.name.indexOf('手机号') > -1) {
                          name = '手机号';
                        } else if (app.name.indexOf('证件类型') > -1) {
                          name = '证件类型';
                        } else if (app.name.indexOf('性别') > -1) {
                          name = '性别';
                        } else if (app.name.indexOf('生日') > -1) {
                          name = '生日';
                        } else if (app.name.indexOf('邮箱') > -1) {
                          name = '邮箱';
                        } else if (app.name.indexOf('证件号') > -1) {
                          name = '证件号';
                        }
                        if (name) {
                          let has = this.showdata[index][index1].item.find(i => {
                            var _i$name;
                            return (_i$name = i.name) === null || _i$name === void 0 ? void 0 : _i$name.includes(name);
                          });
                          if (has && has.inputKey != app.inputKey) {
                            res = false;
                          }
                        }
                      });
                    }
                    if (!res) {
                      return callback(new Error(this.$t('本人信息与投保人不一致')));
                    }
                  }
                  return callback();
                }
              },
              trigger: 'change'
            }];
            // }
          });
        });
      });
      return obj;
    }
  },
  watch: {
    templateData: {
      handler(val) {
        this.data = val;
        this.showdata.splice(0, this.showdata.length);
        this.showdata.push(recursionCopy(this.templateData));
        this.$emit('updateForm', recursionCopy(this.showdata));
      },
      deep: true
    },
    formResult(val) {
      if (val) {
        this.validateForm();
        // this.$emit('validate');
      }
    },
    checkFieldData: {
      handler(val) {
        if (val.length) {
          this.appendCheckResult(val);
        }
      },
      deep: true
    }
  },
  mounted() {
    // this.getArea();
    this.showdata.push(recursionCopy(this.templateData));
    this.$emit('updateForm', recursionCopy(this.showdata));
    this.getBlackResource();
  },
  methods: {
    async getBlackResource() {
      balckListResource({}).then(res => {
        console.log(res, 'balckListResource');
        res && Array.isArray(res) && res.forEach(item => {
          if (item.blacklistType === 'company') {
            this.companyBlackList.push(item.companyName);
          } else if (item.blacklistType === 'person') {
            this.personBlackList.push(item.idNo);
          }
        });
      });
    },
    addInfo() {
      this.showdata.push(recursionCopy(this.templateData));
      this.showdata.forEach((item, index) => {
        item.forEach((item1, index1) => {
          if (item1.item.findIndex(i => i.code == 'applicantType' && i.inputKey == 'COMPANY') > -1) {
            item1.item.forEach((item2, index2) => {
              this.showdata[index][index1].item[index2].inputKey = this.showdata[0][index1].item[index2].inputKey;
              this.showdata[index][index1].item[index2].disabled = false;
            });
          }
        });
      });
      this.$emit('updateForm', recursionCopy(this.showdata));
    },
    delInfo(i) {
      this.showdata.splice(i, 1);
      this.$emit('updateForm', recursionCopy(this.showdata));
    },
    async getArea() {
      this.areaList = await planArea({
        level: 3
      });
      this.areaList = this.areaList.map(item => {
        item.child.map(i => {
          if (i.name == '全部') {
            i.disabled = true;
          }
        });
        return item;
      });
    },
    // 校验表单
    validateForm() {
      this.isPass = true;
      console.log(this.showdata, 'showdata');
      this.showdata.map((item, index) => {
        item.map((item1, index1) => {
          // 'formRef' + index + index1
          this.$refs['formRef' + index + index1][0].validate(valid => {
            if (!valid) {
              this.isPass = false;
            }
          });
        });
      });
      this.showdata.forEach((item, index) => {
        item.forEach((item1, index1) => {
          if (item1.code === 'insured') {
            item1.item.forEach((item2, index2) => {
              if (item2.code == 'insuredIdNo' && item2.inputKey && this.personBlackList.includes(item2.inputKey)) {
                this.$message.error('被保人' + item2.inputKey + '信息已被加入黑名单，请重新输入');
                this.isPass = false;
              }
              if (item2.name === '被保公司名称' && item2.inputKey && this.companyBlackList.includes(item2.inputKey)) {
                this.$message.error('被保公司' + item2.inputKey + '信息已被加入黑名单，请重新输入');
                this.isPass = false;
              }
            });
          }
        });
      });
      this.$emit('validate', this.isPass);
    },
    // 追加错误验证消息
    appendCheckResult(val) {
      val.forEach((_val, valIndex) => {
        if (_val.isCheck) {
          for (const key in _val) {
            const element = _val[key];
            this.showdata[valIndex].map((data, dataIndex) => {
              if (data.code == key) {
                element.map(ele => {
                  let findIndex = data.item.findIndex(i => i.code == ele.code);
                  if (findIndex > -1 && ele.checkResult) {
                    this.showdata[valIndex][dataIndex].item[findIndex].checkResult = ele.checkResult;
                  }
                });
              }
            });
          }
        }
      });
      // 重新校验
      this.validateForm();
    },
    updateForm(e, display, i, index, index1) {
      let currentObj = this.showdata[i][index].item[index1];
      currentObj.checkResult = '';
      if (this.showdata[i][index].code == 'commonInfo' && (currentObj.code == 'startDate' || currentObj.code == 'endDate')) {
        this.showdata[i].forEach((data, dIndex) => {
          if (data.code == 'insured') {
            data.item.forEach((item, iIndex) => {
              if (item.code == 'insuredIdNo') {
                this.showdata[i][dIndex].item[iIndex].checkResult = '';
              }
            });
          }
        });
      }
      if (this.showdata[i][index].code == 'applicant' && currentObj.name != '与投保人关系') {
        // 投保人信息改变 被保人为本人信息跟着改变
        let _insuredI = this.showdata[i].findIndex(_f => _f.code == 'insured');
        let is01 = this.showdata[i][_insuredI].item.findIndex(_f => _f.name == '与投保人关系' && _f.inputKey == '01');
        if (is01 > -1) {
          this.applicantAssignInputKey(currentObj, i, _insuredI, true);
        }
        let company = this.showdata[i][index].item.findIndex(c => c.code == 'applicantType' && c.inputKey == 'COMPANY');
        if (company > -1 && this.isAdd) {
          this.showdata.forEach((item, _i) => {
            item.forEach((item1, _i1) => {
              if (item1.code == 'applicant') {
                item1.item.forEach((item2, _i2) => {
                  this.showdata[_i][_i1].item[_i2].inputKey = this.showdata[0][_i1].item[_i2].inputKey;
                });
                // this.showdata[_i][_i1] = recursionCopy(this.showdata[0][_i1]);
              }
            });
          });
        }
      }
      if (display == 'radio') {
        // 投保类型切换清空表单数据
        this.showdata = [this.templateData];
        this.showdata[0][index].item.splice(1, this.showdata[0][index].item.length - 1);
        if (e.target.value == 'NATURAL_PERSON') {
          this.showdata[0][index].item.push(...this.showdata[0][index].personal);
        } else {
          this.showdata[0][index].item.push(...this.showdata[0][index].company);
        }
        this.showdata[0][index].item[index1].inputKey = e.target.value;
      } else if (display == 'dropDownBox' && currentObj.name == '与投保人关系') {
        this.showdata[i][index].item.map((item4, i4) => {
          item4.disabled = false;
        });
        // 处理与投保人关系本人和非本人的逻辑
        // this.showdata.map((item, _i) => {
        this.showdata[i].map((item1, _i2) => {
          item1.item.map((item2, i2) => {
            if (item2.name == '与投保人关系') {
              if (item2.inputKey != '01') {
                // 非本人清空
                this.showdata[i][index].item.map((item3, i3) => {
                  if (item3.name != '与投保人关系') {
                    if (this.showdata[i][index].item[i3].display == 'dropDownBox') {
                      if (this.showdata[i][index].item[i3].name == '证件类型') {
                        this.showdata[i][index].item[i3].inputKey = 'IDCARD';
                      } else {
                        this.showdata[i][index].item[i3].inputKey = undefined;
                      }
                    } else if (this.showdata[i][index].item[i3].display == 'dropDownBox(region)') {
                      this.showdata[i][index].item[i3].inputKey = [];
                    } else {
                      this.showdata[i][index].item[i3].inputKey = '';
                    }
                  }
                });
              } else {
                // 本人 和投保人信息一致赋值
                let applicantIndex = this.showdata[i].findIndex(f => f.code == 'applicant');
                this.showdata[i][applicantIndex].item.map((item3, i3) => {
                  this.applicantAssignInputKey(item3, i, index, true);
                });
              }
              this.$refs['formRef' + i + _i2][0].resetFields();
            }
          });
          // });
        });
      } else if (display == 'dropDownBox(region)') {
        if (currentObj.inputKey.length == 3) {
          let arr = [];
          this.areaList.map(item => {
            if (item.code == currentObj.inputKey[0]) {
              arr.push(item.name);
              item.children.map(item2 => {
                if (item2.code == currentObj.inputKey[1]) {
                  arr.push(item2.name);
                  item2.children.map(item3 => {
                    if (item3.code == currentObj.inputKey[2]) {
                      arr.push(item3.name);
                    }
                  });
                }
              });
            }
          });
          this.showdata[i][index].item[index1].inputValue = arr.join(' ');
        }
      }
      // this.$refs['formRef' + i + index][0].resetFields();
      this.$emit('updateForm', recursionCopy(this.showdata));
    },
    applicantAssignInputKey(obj, i, index, disabled) {
      let name = '';
      if (obj.name.indexOf('姓名') > -1) {
        name = '姓名';
      } else if (obj.name.indexOf('手机号') > -1) {
        name = '手机号';
      } else if (obj.name.indexOf('证件类型') > -1) {
        name = '证件类型';
      } else if (obj.name.indexOf('性别') > -1) {
        name = '性别';
      } else if (obj.name.indexOf('生日') > -1) {
        name = '生日';
      } else if (obj.name.indexOf('邮箱') > -1) {
        name = '邮箱';
      } else if (obj.name.indexOf('证件号') > -1) {
        name = '证件号';
      }
      if (name) {
        this.showdata[i][index].item.forEach((item4, i4) => {
          if (disabled) {
            if (item4.name.indexOf(name) > -1) {
              this.showdata[i][index].item[i4].inputKey = obj.inputKey;
              this.showdata[i][index].item[i4].disabled = true;
            }
          } else {
            if (item4.name.indexOf(name) > -1) {
              this.showdata[i][index].item[i4].inputKey = item4.display != 'dropDownBox(region)' ? undefined : [];
              if (this.isAdd) {
                this.showdata[i][index].item[i4].disabled = false;
              }
            }
          }
        });
      }
    }
  }
};